import { Navigate, Outlet, useParams } from 'react-router-dom';

import Navbar from '@App/components/Navbar/Navbar';

import { CASE_STUDY_SECTIONS, CASE_STUDY_TITLES } from './case-study.constants';

import './case-study.css';

function CaseStudy() {
  const { caseStudyId } = useParams();

  if (!caseStudyId || !CASE_STUDY_SECTIONS[caseStudyId]) {
    return <Navigate to="/" />;
  }

  return (
    <div className="case-study">
      <Navbar breadcrumbs={CASE_STUDY_SECTIONS[caseStudyId] ?? []} />
      <div className="case-study__content">
        <h1 className="case-study__title">{CASE_STUDY_TITLES[caseStudyId]}</h1>
        <Outlet context={{ sections: CASE_STUDY_SECTIONS[caseStudyId] ?? [] }} />
      </div>
    </div>
  );
}

export default CaseStudy;
